// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/main/'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { rentPriceMapReducers } from 'stores'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas/index'

// Create the store
const sagaMiddleware = createSagaMiddleware()
let store = createStore(rentPriceMapReducers, applyMiddleware(sagaMiddleware))
sagaMiddleware.run(rootSaga)

// Render the main component into the dom
const rootElement = document.getElementById('app')

if (rootElement != null) {
  let base = (
    <Provider store={store}>
      <App />
    </Provider>
  )

  // Use render instead of hydrate, since we seem to have attribute mismatches
  ReactDOM.render(base, rootElement)
}



// WEBPACK FOOTER //
// ./src/index.js